import React, { useEffect } from 'react';

import PropTypes from 'prop-types';
import { Form } from 'semantic-ui-react';

import clsx from 'clsx';
import _get from 'lodash/get';

import { DEFAULT_VIDEO_SOURCE } from '../../VideoPlayerEditor.constants';
import { VideoPlayerSourcePropType } from '../../VideoPlayerEditor.types';

import './VideoPlayerSources.scss';

const propTypes = {
  videoSourceOptions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: VideoPlayerSourcePropType.isRequired,
    }),
  ).isRequired,
  selectedSource: VideoPlayerSourcePropType,
  onChange: PropTypes.func.isRequired,
};

const defaultProps = {
  selectedSource: undefined,
};

export default function VideoPlayerSources({ videoSourceOptions, selectedSource, onChange }) {
  useEffect(() => {
    // Auto-select the only source if there's just one option
    if (videoSourceOptions.length === 1) {
      const onlyOption = _get(videoSourceOptions, '[0].value', DEFAULT_VIDEO_SOURCE);
      if (onlyOption !== selectedSource) {
        onChange(null, { source: onlyOption });
      }
    }
  }, [videoSourceOptions, selectedSource, onChange]);

  const className = clsx('video-player-sources', {
    'video-player-sources--single': videoSourceOptions.length <= 1,
  });

  return (
    <div className={className}>
      <strong className="field-label">Source</strong>

      <Form.Group inline>
        {videoSourceOptions.map(({ label, value }) => (
          <Form.Field key={value}>
            <Form.Radio
              label={label}
              value={value}
              checked={value === selectedSource}
              onClick={(e) => onChange(e, { source: value })}
            />
          </Form.Field>
        ))}
      </Form.Group>
    </div>
  );
}

VideoPlayerSources.propTypes = propTypes;
VideoPlayerSources.defaultProps = defaultProps;
